import React, {Component} from 'react';
import { compose } from 'recompose';
import withAuthorization from '../../Session/withAuthorization';
import { Row, Col, Button} from 'reactstrap';
import { db } from '../../../firebase';
import ReactTable from 'react-table';
import * as routes from '../../../constants/routes'
import Spinner from '../../Spinner';
import { functions } from '../../../firebase/firebase';
import { toast } from 'react-toastify';

class AdminUsers extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          users: [],
          isLoading:true
        };
    }

    componentDidMount(){
        db.onceGetUsers().then((usersSnapshot)=>{
            let usersObj = usersSnapshot.val();
            let users = this.proccessUserData(usersObj);

            return this.setState(()=>({
                users:users,
                isLoading:false
            }))
        })
    }

    proccessUserData(usersObj){
        let users = [];
        let options = { year: 'numeric', month: 'numeric', day: 'numeric', hour:'numeric', minute:'numeric' };

        for (var key in usersObj) {
            if (usersObj.hasOwnProperty(key)) {
                let c = {...usersObj[key]};
                c.createDate = new Date(c.dateCreated).toLocaleDateString("lt-LT",options);
                c.endDate = new Date(c.dateEdited).toLocaleDateString("lt-LT",options);
                c.uid = key;
                users.push(c);
            }
        }
        return users;
    }

    deleteUser(userId){
        this.setState({
            isLoading:true
        });
        var deleteUserFunction = functions.httpsCallable('deleteUser');

        deleteUserFunction({userId:userId})
        .then((snapshot)=>{
            this.setState({
                isLoading:false
            });
            toast.success("Vartotojas ištrintas",{
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    render(){

        const columns = [{
            Header: 'Slapyvardis',
            accessor: 'alias',
        },
        {
            Header:"Įmonė",
            accessor:'company',
        },
        {
            Header:"Sukūrimo data",
            accessor:'createDate',
        },
        {
            Header:"Modifikavimo data",
            accessor:'endDate',
        },
        {
            Header: '',
            accessor:'uid',
            width: 150,
            Cell: (row)=>(
                <a href={routes.EDIT_USER + '/' + row.row.uid} className='w-100'>Redaguoti</a>),
            sortable:false
        },
        {
            Header: '',
            accessor:'uid',
            width: 170,
            Cell: (row)=>(
                <a href={routes.EDIT_USER_PASSWORD + '/' + row.row.uid} className='w-100'>Keisti slaptažodį</a>),
            sortable:false
        },
        {
            Header: '',
            accessor:'uid',
            width: 170,
            Cell: (row)=>(
                <Button color="link" className="p-0" onClick={()=>this.deleteUser(row.row.uid)}>Ištrinti vartotoją</Button>),
            sortable:false
        }
    ]

        const { users, isLoading } = this.state;

        if(isLoading){
            return (<Spinner></Spinner>)
        }
        else{
            return(
                <Row>
                    <Col>
                        <ReactTable
                        data={users}
                        columns={columns}
                        minRows={0}
                        defaultPageSize={5}
                        nextText={"Kitas"}
                        previousText={"Ankstesnis"} 
                        pageText={"Puslapis"}
                        ofText={"iš"}
                        rowsText={"eilutės"} 
                    />
                    </Col>
                </Row>
            ) 
        }
    }
}

const authCondition = (authUser, token) => {
    return !!authUser && token.claims.isAdmin;
    
  };

  export default compose(withAuthorization(authCondition))(AdminUsers);


// WEBPACK FOOTER //
// ./src/components/Users/UsersTable/index.js